import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from "next/router";
import { routeToDomain } from "../../../../../utils/route.utils";
import { contactEmail, contactNumber } from "../../../../../utils/constants";
import { displayTop15Category } from "../../../../../utils/constants/landingPage";
import { useIsMobile } from "../../../../../hooks/useIsMobile";
import AppStoreLogo from "../../../../Icons/AppStoreLogo";
import PlayStoreLogo from "../../../../Icons/PlayStoreLogo";
import Link from "next/link";

export default function Footer({ isBottomPadding }) {
  const router = useRouter();
  const { isMobile } = useIsMobile();
  const currentUser = useSelector((val) => val?.currentUser?.currentUser);

  const socialHandles = [
    {
      id: 1,
      icon: <FontAwesomeIcon icon={faLinkedin} />,
      url: "https://www.linkedin.com/company/seekhoapp/",
    },
    {
      id: 2,
      icon: <FontAwesomeIcon icon={faYoutube} />,
      url: "https://www.youtube.com/channel/UCs5t6HkoGqFcOSSVyL5W0mA",
    },
    {
      id: 3,
      icon: <FontAwesomeIcon icon={faInstagram} />,
      url: "https://www.instagram.com/seekhoapp/",
    },
    {
      id: 4,
      icon: <FontAwesomeIcon icon={faFacebook} />,
      url: "https://www.facebook.com/profile.php?id=100064040891834",
    },
    {
      id: 5,
      icon: <FontAwesomeIcon icon={faTwitter} />,
      url: "https://x.com/seekhoapp",
    },
  ];

  const companyDetails = [
    {
      id: 2,
      title: "Our Team",
      link: `${routeToDomain}/team`,
    },
    {
      id: 1,
      title: "Privacy Policy",
      link: `${routeToDomain}/privacy-policy`,
    },
    {
      id: 3,
      title: "Cancellation Policy",
      link: `${routeToDomain}/cancellation-policy`,
    },
    {
      id: 4,
      title: "Terms and conditions",
      link: `${routeToDomain}/terms-and-conditions`,
    },
    {
      id: 5,
      title: "FAQs",
      link: `${routeToDomain}/faq`,
    },
    {
      id: 6,
      title: "Contact Us",
      link: `${routeToDomain}/contact-us`,
    },
    {
      id: 7,
      title: "Blogs",
      link: `${routeToDomain}/blog`,
    },
    // Adding login only if user is loggedOut
    ...(!currentUser?.id
      ? [
          {
            id: 8,
            title: "LogIn",
            link: `${routeToDomain}/login`,
          },
        ]
      : []),
  ];

  const categoryDetails = [
    ...displayTop15Category,
    { title: "Explore All", slug: "" },
  ];

  return (
    <div
      className={` bg-[#1d1d1d] pt-10 !pb-24 ${
        isBottomPadding ? "!mb-40" : ""
      } lg:!pb-20`}
    >
      <div className="w-[90%] mx-auto lg:flex lg:justify-between lg:w-[80%]">
        <div>
          <img
            src="/assets/headerlogo.webp"
            alt="seekho-footer-logo"
            className="w-[100px] cursor-pointer"
            onClick={() => router.push("/")}
          />

          {/* <DownloadTheAppCTA
            onSection="Footer"
            className="mt-3 !py-2 text-[14px] lg:!spy-3"
          /> */}

          <div className="mt-4 flex gap-x-2 items-center lg:flex-row-reverse lg:!justify-end">
            <AppStoreLogo
              className="w-[120px]"
              mobileStatus={isMobile ? "AppStore_Footer_CTA" : undefined}
              desktopStatus={!isMobile ? "AppStore_Footer_CTA" : undefined}
            />
            <PlayStoreLogo
              className="w-[120px] h-[39px]"
              mobileStatus={isMobile ? "PlayStore_Footer_CTA" : undefined}
              desktopStatus={!isMobile ? "PlayStore_Footer_CTA" : undefined}
            />
          </div>

          <div className="flex gap-x-8 mt-4">
            {socialHandles?.map((item) => {
              return (
                <a
                  href={item?.url}
                  target="_blank"
                  key={item?.id}
                  className="text-white text-[20px] lg:text-[28px]"
                  rel="noreferrer"
                >
                  {item?.icon}
                </a>
              );
            })}
          </div>

          <div className="hidden mt-4 text-[14px] lg:block">
            <a
              href={`mailto: ${contactEmail}`}
              className="text-gray-400 no-underline"
            >
              {contactEmail}
            </a>
            <a
              href={`tel: ${contactNumber}`}
              className="text-gray-400 no-underline"
            >
              {" "}
              | {contactNumber}
            </a>

            <div className="flex gap-x-2 items-center mt-3">
              <FontAwesomeIcon icon={faLocationDot} className="text-gray-400" />
              <a
                href="https://www.google.com/maps/place/Seekho/@12.9221626,77.6695965,15z/data=!4m2!3m1!1s0x0:0x5d9c2bc14d5e1382?sa=X&ved=1t:2428&ictx=111"
                target="_blank"
                className="text-gray-400 no-underline hover:text-white"
                rel="noreferrer"
              >
                Bellandur, Bengaluru, 560103, IN
              </a>
            </div>
            <p className="mt-3 text-gray-400">
              © Keyaro Edutech Pvt Ltd. All rights reserved.
            </p>
          </div>
        </div>

        <div className="!mt-10 lg:!mt-0">
          <h6
            style={{ fontFamily: "Inter" }}
            className="border-b-4 pb-2 text-white border-[#804ee8] cursor-pointer"
            onClick={() => router.push("/category")}
          >
            Categories
          </h6>
          <div className="grid grid-cols-3 gap-x-5 gap-y-4 lg:grid-cols-3">
            {categoryDetails?.map((item) => {
              return (
                <Link
                  href={`/category/${item?.slug}`}
                  key={item?.slug}
                  passHref
                >
                  <a
                    className="no-underline text-[12px] mt-2 font-normal cursor-pointer text-gray-400 hover:text-white first:mt-2 lg:text-[14px]"
                    style={{ fontFamily: "Inter" }}
                  >
                    {item.title}
                  </a>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="!mt-10 lg:!mt-0">
          <h6
            style={{ fontFamily: "Inter" }}
            className="border-b-4 pb-2 text-white border-[#804ee8]"
          >
            Company
          </h6>
          <div className="grid grid-cols-2 gap-x-5 gap-y-4">
            {companyDetails?.map((item) => {
              return (
                <Link href={item?.link} key={item?.id}>
                  <a
                    className="no-underline text-[12px] !mt-2 font-normal text-gray-400 cursor-pointer hover:text-white first:!mt-2 lg:text-[14px]"
                    style={{ fontFamily: "Inter" }}
                  >
                    {item.title}
                  </a>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="mt-8 text-[13px] lg:hidden">
          <a
            href={`mailto: ${contactEmail}`}
            className="text-gray-400 no-underline"
          >
            {contactEmail}
          </a>
          <a
            href={`tel:${contactNumber}`}
            className="text-gray-400 no-underline"
          >
            {" "}
            | {contactNumber}
          </a>
          <div className="flex gap-x-2 items-center mt-3">
            <FontAwesomeIcon icon={faLocationDot} className="text-gray-400" />
            <a
              href="https://www.google.com/maps/place/Seekho/@12.9221626,77.6695965,15z/data=!4m2!3m1!1s0x0:0x5d9c2bc14d5e1382?sa=X&ved=1t:2428&ictx=111"
              target="_blank"
              className="text-gray-400 no-underline hover:text-white"
              rel="noreferrer"
            >
              Bellandur, Bengaluru, 560103, IN
            </a>
          </div>
          <p className="mt-3 text-gray-400">
            © Keyaro Edutech Pvt Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
